import React, { useRef } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Typography,
    Box,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import { useReactToPrint } from "react-to-print";
import html2pdf from "html2pdf.js";
import { formatNumber } from "../utils/helpers";

const InvoiceModal = ({ show, handleClose, order }) => {
    const componentRef = useRef();
    console.log("InvoiceModal order:", order);
    // const handlePrint = useReactToPrint({
    //   content: () => componentRef.current,
    //   documentTitle: `HoaDon-${order?.orderCode || order._id}`,
    // });
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const handleExportPDF = () => {
        const element = componentRef.current;

        const options = {
            margin: 0.3,
            filename: `HoaDon-${order.orderCode || order._id}.pdf`,
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
        };

        html2pdf().set(options).from(element).save();
    };

    if (!order) return null;

    const formattedDate =
        new Date(order.createdAt).toLocaleTimeString("vi-VN", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        }) +
        " " +
        new Date(order.createdAt).toLocaleDateString("vi-VN");

    console.log("Order data:", order);
    return (
        <>
            <Dialog
                open={show}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
                fullWidth
                maxWidth="lg"
                scroll="paper"
                fullScreen={fullScreen}
            >
                <DialogTitle sx={{ m: 0, p: 2 }}>
                    <Typography>
                        Hóa Đơn #{order?.orderCode || order._id}
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Box
                        ref={componentRef}
                        className="print-section"
                        sx={{
                            fontFamily: "Arial, sans-serif",
                            color: "#000",
                            fontSize: "14px",
                        }}
                    >
                        {/* Tiêu đề */}
                        {/* <Box sx={{ textAlign: "center", mb: 3 }}>
                            <Typography
                                fontWeight="bold"
                                fontSize="18px"
                                textTransform="uppercase"
                                sx={{ fontFamily: "Arial, sans-serif" }}
                            >
                                XƯỞNG MAY ĐỒ BỘ PIJAMA 3CE
                            </Typography>
                            <Typography fontWeight="bold" fontSize="14px">
                                CHUYÊN SẢN XUẤT VẢI : LATIN + XƯỚC
                            </Typography>
                            <Typography fontWeight="bold" fontSize="14px">
                                NHẬN ĐẶT MAY ĐỘC QUYỀN MẠC RIÊNG
                            </Typography>
                            <Typography>
                                ĐC Xưởng may: 56 Tân Thới Nhất 8, P.TTN, Quận 12
                            </Typography>
                        </Box> */}

                        {/* Tiêu đề hóa đơn */}
                        <Typography
                            variant="h6"
                            align="center"
                            fontWeight="bold"
                            sx={{ mb: 6 }}
                        >
                            HÓA ĐƠN BÁN HÀNG
                        </Typography>

                        {/* Thông tin đơn hàng */}
                        <Typography>
                            <strong>Số HĐ:</strong>{" "}
                            {order.orderCode || order._id}
                        </Typography>
                        <Typography>
                            <strong>Ngày:</strong> {formattedDate}
                        </Typography>
                        <Typography>
                            <strong>Khách hàng: {order.customer?.name}</strong>
                        </Typography>

                        {/* Bảng sản phẩm */}
                        <Table sx={{ width: "100%", mt: 2, border: "2px solid black" }} size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <strong>Đơn giá</strong>
                                    </TableCell>
                                    <TableCell align="right">
                                        <strong>SL</strong>
                                    </TableCell>
                                    <TableCell align="right">
                                        <strong>Thành tiền</strong>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {order.items.map((item, idx) => (
                                    <TableRow key={idx}>
                                        <TableCell>
                                            <strong>
                                                {item?.name}
                                            </strong>
                                            <Box>
                                                <span
                                                    style={{
                                                        fontWeight: 900,
                                                        marginRight: 8,
                                                        WebkitTextStroke:
                                                            "1px black",
                                                    }}
                                                >
                                                    {/* đơn giá trừ discount */}
                                                    {item.priceAfterDiscount?.toLocaleString()}
                                                </span>
                                                {/* Giá gốc */}
                                                <span
                                                    style={{
                                                        textDecoration:
                                                            "line-through",
                                                        color: "gray",
                                                    }}
                                                >
                                                    {(item.priceAfterDiscount !==
                                                        item.priceAdjust &&
                                                        item?.priceAdjust?.toLocaleString()) ||
                                                        ""}
                                                </span>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="right">
                                            {" "}
                                            <strong>{item.quantity}</strong>
                                        </TableCell>
                                        <TableCell align="right">
                                            {/* Đơn giá * với số lượng */}
                                            <strong>
                                                {" "}
                                                {(
                                                    item.priceAfterDiscount *
                                                    item.quantity
                                                )?.toLocaleString()}
                                            </strong>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>

                        {/* Gạch đứt phân cách */}
                        <Box sx={{ borderTop: "1px dashed black", my: 2 }} />

                        {/* Tổng hợp giá trị */}
                        <Box sx={{ width: "100%", mt: 1 }}>
                            <Box display="flex" justifyContent="space-between">
                                <Typography>
                                    <strong>Tổng tiền hàng:</strong>
                                </Typography>
                                <Typography>
                                    <strong>
                                        {formatNumber(order.totalAmount)}
                                    </strong>
                                </Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between">
                                <Typography>
                                    <strong>Khách thanh toán:</strong>
                                </Typography>
                                <Typography>
                                    <strong>
                                        {formatNumber(order.amountPaid)}
                                    </strong>
                                </Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between">
                                <Typography>
                                    <strong>Công nợ cũ:</strong>
                                </Typography>
                                <Typography>
                                    <strong>
                                        {formatNumber(order.debt_old)}
                                    </strong>
                                </Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between">
                                <Typography fontWeight="bold">
                                    Tổng công nợ:
                                </Typography>
                                <Typography fontWeight="bold">
                                    <strong>{formatNumber(order.debt)}</strong>
                                </Typography>
                            </Box>
                        </Box>

                        {/* In nghiêng - Không đồng chẵn */}
                        {/* <Typography sx={{ mt: 2 }} fontStyle="italic">
              Không đồng chẵn
            </Typography> */}

                        {/* Cảm ơn */}
                        <Typography
                            align="center"
                            sx={{ mt: 3 }}
                            fontStyle="italic"
                        >
                            Cảm ơn và hẹn gặp lại!
                        </Typography>
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={handleClose}
                        color="secondary"
                        variant="outlined"
                    >
                        Đóng
                    </Button>
                    {/* <Button onClick={handlePrint} color="primary" variant="contained">
            In
          </Button> */}
                    <Button
                        onClick={handleExportPDF}
                        color="success"
                        variant="contained"
                    >
                        Xuất PDF
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Hidden section for printing */}
            <div style={{ display: "none" }}>
                <div ref={componentRef}>
                    {/* Same content can be reused here if you prefer a cleaner print version */}
                </div>
            </div>
        </>
    );
};

export default InvoiceModal;
